import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateUserRoles } from '../api/users';
import { Queries } from '../types/queries';
import { UpdateUserRolesRequest } from '../types/users';

interface UpdateUserRolesVariables {
  userId: number;
  request: UpdateUserRolesRequest;
}

/** Updates a user's roles and refreshes the user directory after success. */
const useUpdateUserRoles = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, request }: UpdateUserRolesVariables) => updateUserRoles(userId, request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [Queries.UserList] }),
  });
};

export default useUpdateUserRoles;
